/* src/app/rating/video/video.component.scss */
/*# sourceMappingURL=video.component.css.map */
